import React, { useCallback } from 'react';
import { css } from '@emotion/react';

import theme from "../../theme";
import { useAppState } from "../contexts/AppContext";
import { HomeUser } from "./utils/UserSession";
import { sendCorporate } from "../includes/navigate";
import Button from "./Button";
import { logout } from "../includes/auth";

const ProfileContextMenu: React.FC = () => {
    const [appState] = useAppState();

    const user: HomeUser = appState?.user;

    const onLogoutClick = useCallback(() => {
        logout().then(() => sendCorporate(""));
    }, []);

    const stopEvent = useCallback((e: any) => e.stopPropagation(), [])

    return (
        <div css={profileContextMenuStyle}>
            <div css={profileContextMenuContentStyle}>
                <div css={contextMenuHeaderStyle} onClick={stopEvent}>
                    <div css={nameStyle}>{user.FirstName} {user.Surname}</div>
                    <div css={emailStyle}>{user.Email}</div>
                </div>
                <Button
                    onClick={onLogoutClick}
                    css={buttonStyle}
                >
                    Log out
                </Button>
            </div>
        </div>
    )
}

const profileContextMenuStyle = css`
    position: absolute;
    top: 100%;
    right: 0;
    box-shadow: inset ${theme.borderAndShadow.dropShadow};
    cursor: default;
    border-radius: 0 0 23px 23px;
    z-index: ${theme.zIndex.zIndexHigher};
    background-color: ${theme.colours.concrete};
    padding: 13px;

    ${theme.breakpoints.up("3xl")} {
        width: 282px;
    }

    ${theme.breakpoints.between("xl", "xxl")} {
        width: 241px;
    }
`;

const profileContextMenuContentStyle = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 3px;
`;

const contextMenuHeaderStyle = css`
    padding-left: 10px;
    width: 100%;
`;

const buttonStyle = css`
    width: 110px;
    border-radius: ${theme.borderAndShadow.largerRadius1};
`;

const emailStyle = css`
    font-size: 14px;
    line-height: 17px;
    margin: 5px 0 28px;
    ${theme.utils.oneLineEllipsis};
`;

const nameStyle = css`
    font-size: 30px;
    line-height: 37px;
    color: ${theme.colours.curiousBlue};
    font-weight: ${theme.fonts.weights.bold};
    ${theme.utils.oneLineEllipsis};

    ${theme.breakpoints.only("xxl")} {
        font-size: 28px;
        line-height: 34px;
    }
`;

export default ProfileContextMenu;
